const FORTHEM_TIER_NAME_ALLACCESS = "AF+";
const FORTHEM_TIER_NAME_MEDIA = "AF Media";
const FORTHEM_TIER_NAME_SUPPORT = "Support";
class MembershipService {
  constructor() {
    this.cache = /* @__PURE__ */ new Map();
    this.CACHE_DURATION = 5 * 60 * 1e3;
  }
  // 5 minutes cache
  /**
   * Get subscription status for a customer
   */
  async getSubscriptionStatus(shopifyCustomerId) {
    const cached = this.cache.get(shopifyCustomerId);
    if (cached && Date.now() - cached.timestamp < this.CACHE_DURATION) {
      return cached.data;
    }
    try {
      const response = await fetch(`https://autostraddle.forthem.com/api/toki/getSubscriptionStatus/${shopifyCustomerId}`);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      this.cache.set(shopifyCustomerId, {
        data,
        timestamp: Date.now()
      });
      return data;
    } catch (error) {
      console.error("Error fetching subscription status:", error);
      return {
        success: false,
        memberships: []
      };
    }
  }
  /**
   * Determine if a customer's membership is upgradable
   */
  getMembershipStatus(memberships) {
    if (!memberships || memberships.length === 0) {
      return "not-member";
    }
    const hasUpgradableMembership = memberships.some((membership) => {
      if (membership.name === FORTHEM_TIER_NAME_ALLACCESS && membership.selectedPlanOption === "Monthly") {
        return true;
      }
      if (membership.name === FORTHEM_TIER_NAME_MEDIA) {
        return true;
      }
      return false;
    });
    if (hasUpgradableMembership) {
      return "upgradable";
    }
    return "not-upgradeable";
  }
  /**
   * Get customer ID from Shopify customer data
   */
  getCustomerId() {
    var _a;
    const customer = window.customer;
    return ((_a = customer == null ? void 0 : customer.id) == null ? void 0 : _a.toString()) || null;
  }
  /**
   * Check if customer is logged in
   */
  isCustomerLoggedIn() {
    const customer = window.customer;
    return !!customer && !!customer.id;
  }
  /**
   * Get full membership status for current customer
   */
  async getCurrentMembershipStatus() {
    const customerId = this.getCustomerId();
    if (!customerId) {
      return {
        status: "not-member",
        memberships: [],
        customerId: null
      };
    }
    try {
      const response = await this.getSubscriptionStatus(customerId);
      const status = this.getMembershipStatus(response.memberships);
      return {
        status,
        memberships: response.memberships,
        customerId
      };
    } catch (error) {
      console.error("Error getting current membership status:", error);
      return {
        status: "not-member",
        memberships: [],
        customerId
      };
    }
  }
  /**
   * Clear cache for specific customer or all customers
   */
  clearCache(customerId) {
    if (customerId) {
      this.cache.delete(customerId);
    } else {
      this.cache.clear();
    }
  }
}
const membershipService = new MembershipService();
const membershipService$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  membershipService
}, Symbol.toStringTag, { value: "Module" }));
export {
  FORTHEM_TIER_NAME_ALLACCESS as F,
  FORTHEM_TIER_NAME_SUPPORT as a,
  membershipService$1 as b,
  membershipService as m
};
